import { render, staticRenderFns } from "./moshoushijie.vue?vue&type=template&id=08570200&scoped=true&"
import script from "./moshoushijie.vue?vue&type=script&lang=js&"
export * from "./moshoushijie.vue?vue&type=script&lang=js&"
import style0 from "./moshoushijie.vue?vue&type=style&index=0&id=08570200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08570200",
  null
  
)

export default component.exports